/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Dubbing_Export_TitleInputs */



/**
* | output |
* | --- |
* | "Audio Dubbing Export" |
*
* @param {Audio_Dubbing_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_dubbing_export_title = /** @type {((inputs?: Audio_Dubbing_Export_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Dubbing_Export_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation du doublage audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audio-Synchronisation exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione doppiaggio audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт аудиодубляжа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportación de doblaje de audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("音频配音导出")
	if (locale === "ja") return /** @type {LocalizedString} */ ("音声吹き替えのエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो डबिंग निर्यात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar dobragem de áudio")
	return /** @type {LocalizedString} */ ("Audio Dubbing Export")
});